import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles(theme => ({
	root: {},
	red: {
		color: theme.palette.error.main
	}
}));